import React from "react";
import CheckIcon from '@mui/icons-material/Check';

const InvoiceStepper = ({ levels = [], currentStatus }) => {
    if (!levels?.length) return null;

    const sortedLevels = [...levels].sort((a, b) => a.Level_step - b.Level_step);

    return (
        <div className="invoice-stepper-wrapper">
            <div className="invoice-stepper">
                {sortedLevels.map((step, index) => {
                    const isPassed = currentStatus > step.Level_step;
                    const isActive = currentStatus === step.Level_step;
                    const isRemaining = currentStatus < step.Level_step;

                    return (
                        <div key={step.Level_Id} className="step-wrapper">
                            {/* Bullet */}
                            <div
                                className={`step-circle 
                  ${isPassed ? "passed" : ""} 
                  ${isActive ? "active" : ""} 
                  ${isRemaining ? "remaining" : ""}`}
                            >
                                {isPassed && <CheckIcon style={{ fontSize: 12, color: "white" }} />}
                            </div>
                            {/* Description under bullet */}
                            <div
                                className={`step-description ${isActive ? "active-desc" : isPassed ? "passed-desc" : "remaining-desc"
                                    }`}
                            >
                                {step.Level_Description}
                            </div>
                            {/* Line */}
                            {index !== sortedLevels.length - 1 && (
                                <div
                                    className={`step-line ${currentStatus > step.Level_step ? "line-filled" : ""
                                        }`}
                                />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default InvoiceStepper;
